const BACKEND_URI = "https://kidslike-back-end.herokuapp.com/api"

export {
    BACKEND_URI
}